import { createBreakpoint } from "react-use";

export type Breakpoint = keyof typeof breakpoints;
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

const useBreakpoint = createBreakpoint(breakpoints) as () => Breakpoint;
export default useBreakpoint;
